export enum ImportTripsErrorCodes {
    MISSING_COLUMN = 'MISSING_COLUMN',
    INVALID_FORMAT = 'INVALID_FORMAT',
    EMPTY_STRING = 'EMPTY_STRING',
    NOT_FOUND = 'NOT_FOUND',
    NOT_FOUND_OPTIONAL = 'NOT_FOUND_OPTIONAL',
    CONSECUTIVE_CHECKPOINTS = 'CONSECUTIVE_CHECKPOINTS',
    FILE_IS_EMPTY = 'FILE_IS_EMPTY',
    DUPLICATED_TRIP = 'DUPLICATED_TRIP',
    DUPLICATED_ORDER = 'DUPLICATED_ORDER',
    MISSING_CHECKPOINT_TYPE = 'MISSING_CHECKPOINT_TYPE',
    MISSING_REQUIRED_OPTIONAL_COLUMN = 'MISSING_REQUIRED_OPTIONAL_COLUMN',
    MULTIPLE_LOCATIONS_FOR_CHECKPOINT = 'MULTIPLE_LOCATIONS_FOR_CHECKPOINT',
    INVALID_CHECKPOINT_NUMBER_SEQUENCE = 'INVALID_CHECKPOINT_NUMBER_SEQUENCE',
    API_ERROR = 'API_ERROR',
    TRIP_ALREADY_STARTED = 'TRIP_ALREADY_STARTED',
    ORDER_CONFLICT = 'ORDER_CONFLICT',
    INVALID_ORDER = 'INVALID_ORDER',
    INVALID_CARRIER = 'INVALID_CARRIER',
    VEHICLE_BLOCKED = 'VEHICLE_BLOCKED',
    DRIVER_BLOCKED = 'DRIVER_BLOCKED',

    // Template (importer mapping) error codes
    TEMPLATE_PARSE_FAILED = 'TEMPLATE_PARSE_FAILED',
    TEMPLATE_MISSING_PART = 'TEMPLATE_MISSING_PART',
    TEMPLATE_NOT_FOUND = 'TEMPLATE_NOT_FOUND',
    TEMPLATE_UNMAPPED_VALUE = 'TEMPLATE_UNMAPPED_VALUE', // a value missing from a value map that rejects unmatched values
    TRIP_NOT_FOUND = 'TRIP_NOT_FOUND', // update-only template: trip does not exist yet
    TRIP_ALREADY_EXISTS = 'TRIP_ALREADY_EXISTS', // create-only template: trip already exists
    NO_ELIGIBLE_ROWS = 'NO_ELIGIBLE_ROWS', // every row was rejected by the template's policy (mode-agnostic)

    // Service type error codes
    SERVICE_TYPE_NOT_FOUND = 'SERVICE_TYPE_NOT_FOUND', // unknown code, soft-deleted, or from another organization
    SERVICE_TYPE_TRIP_DEFINITION_MISMATCH = 'SERVICE_TYPE_TRIP_DEFINITION_MISMATCH',
    SERVICE_TYPE_DUPLICATED = 'SERVICE_TYPE_DUPLICATED',
    MEASURE_UNIT_NOT_ALLOWED = 'MEASURE_UNIT_NOT_ALLOWED',

    // Rate matching error codes
    CARRIER_MISMATCH = 'CARRIER_MISMATCH',
    AUDIENCE_MISMATCH = 'AUDIENCE_MISMATCH',
    TRIP_TYPE_MISMATCH = 'TRIP_TYPE_MISMATCH',
    DEVICE_GROUP_MISMATCH = 'DEVICE_GROUP_MISMATCH',
    TRIP_TAG_MISMATCH = 'TRIP_TAG_MISMATCH',
    TRIP_DATE_OUTSIDE_VALIDITY_RANGE = 'TRIP_DATE_OUTSIDE_VALIDITY_RANGE',
    RATE_NOT_FOUND = 'RATE_NOT_FOUND',
    RATE_INACTIVE = 'RATE_INACTIVE',
    ROUTE_COST_CONNECTION_ERROR = 'ROUTE_COST_CONNECTION_ERROR',
}
